import { isObject, isFunction } from 'lodash';
import FormControl from '@mui/material/FormControl';
import FormHelperText from '@mui/material/FormHelperText';
import MenuItem from '@mui/material/MenuItem';
import TextField from '@mui/material/TextField';
import PropTypes from 'prop-types';
import { jsx } from '@emotion/react';

// Designer-specified colors

var IRON = '#8C8C8C';
var CHARCOAL = '#191919';
var ERROR = '#DA4453';
var MIST = '#F2F2F2';
var WHITE_BACKGROUND = '#FFFFFF';

var baseStyle = {
  background: WHITE_BACKGROUND
};
var formControlStyle = {
  width: '100%',
  '.MuiFormHelperText-root': {
    color: ERROR
  },
  'MuiOutlinedInput-notchedOutline': {
    color: IRON
  }
};
var helperTextStyle = {
  color: '#d32f2f',
  fontSize: '12px',
  margin: 0
};
var inputLabelPropsStyle = {
  color: IRON
};
var menuItemStyle = {
  color: CHARCOAL
};
var menuPropsStyle = {
  height: '500px',
  marginTop: '.5rem'
};
var presetDisabledStyle = {
  background: "linear-gradient(180deg, ".concat(WHITE_BACKGROUND, " 0%, ").concat(MIST, " 100%)")
};
function renderOptions(options) {
  return options.map(function (item) {
    var value = isObject(item) ? item.value : item;
    var label = isObject(item) ? item.label : item;
    return jsx(MenuItem, {
      value: value,
      key: value
    }, jsx("p", {
      css: menuItemStyle
    }, label));
  });
}
function BasicSelect(_ref) {
  var defaultValue = _ref.defaultValue,
    error = _ref.error,
    id = _ref.id,
    isVisible = _ref.isVisible,
    label = _ref.label,
    name = _ref.name,
    onBlur = _ref.onBlur,
    onChange = _ref.onChange,
    options = _ref.options,
    presetDisabled = _ref.presetDisabled,
    isFullStoryMasked = _ref.isFullStoryMasked,
    value = _ref.value;
  var handleChange = function handleChange(e) {
    if (isFunction(onChange)) {
      onChange(e.target.value);
    }
  };
  var handleBlur = function handleBlur(e) {
    if (isFunction(onBlur)) {
      onBlur(e.target.value);
    }
  };
  var hasError = Boolean(error);
  return jsx("div", null, isVisible && jsx(FormControl, {
    css: formControlStyle,
    disabled: presetDisabled
  }, jsx(TextField, {
    css: [baseStyle, presetDisabled ? presetDisabledStyle : {}, process.env.NODE_ENV === "production" ? "" : ";label:BasicSelect;", process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"],
    disabled: presetDisabled,
    error: !!error,
    id: id,
    InputLabelProps: {
      style: inputLabelPropsStyle,
      htmlFor: {
        id: id
      }
    },
    inputProps: {
      'data-testid': "".concat(id, "-content-input"),
      className: isFullStoryMasked ? 'fs-mask' : ''
    },
    label: label,
    name: name,
    onBlur: handleBlur,
    onChange: handleChange,
    select: true,
    SelectProps: {
      MenuProps: {
        style: menuPropsStyle
      }
    },
    value: value || ''
  }, jsx(MenuItem, {
    value: ""
  }, jsx("em", null, defaultValue)), renderOptions(options)), hasError && jsx(FormHelperText, {
    style: helperTextStyle
  }, error)));
}
BasicSelect.propTypes = {
  defaultValue: PropTypes.string,
  error: PropTypes.string,
  id: PropTypes.string,
  isVisible: PropTypes.bool,
  label: PropTypes.string,
  name: PropTypes.string,
  onBlur: PropTypes.func,
  onChange: PropTypes.func,
  options: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.string), PropTypes.arrayOf(PropTypes.shape({
    value: PropTypes.oneOfType([PropTypes.bool, PropTypes.number, PropTypes.string]),
    label: PropTypes.string
  }))]),
  presetDisabled: PropTypes.bool,
  isFullStoryMasked: PropTypes.bool,
  value: PropTypes.oneOfType([PropTypes.bool, PropTypes.number, PropTypes.string])
};
BasicSelect.defaultProps = {
  isFullStoryMasked: false
};

export { BasicSelect as default };
